var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import './styles.css';
var InputText = function (props) {
    var label = props.label, inicialValue = props.inicialValue, disabled = props.disabled, onChange = props.onChange, placeholder = props.placeholder, name = props.name, resize = props.resize, isPassword = props.isPassword, invisible = props.invisible, maxLength = props.maxLength, width = props.width;
    var value = inicialValue !== undefined ? String(inicialValue) : '';
    if (label.includes('Data')) {
        value = value.split('T').join(' / ');
    }
    return (_jsxs("div", __assign({ className: "containerTextInput" }, { children: [!invisible && (_jsxs("label", __assign({ className: "textInputLabel" }, { children: [label, ":"] }), void 0)), _jsx("input", { name: name, placeholder: placeholder, onChange: onChange, disabled: disabled, value: inicialValue !== undefined ? value : undefined, type: isPassword ? 'password' : 'text', hidden: !!invisible, className: "textInput " + (resize ? 'textInputWidthResized' : 'textInputWidthDefault'), maxLength: maxLength, style: { width: width } }, void 0)] }), void 0));
};
export default InputText;
